export const ServerStatus = {
    ok: { displayName: 'ok', color: 'green' },
    warning: { displayName: 'warning', color: 'orange' },
    error: { displayName: 'error', color: 'red' },
    recovered: { displayName: 'recovered', color: 'cyan' },
};
